import React, { useEffect, useRef } from "react";
import { Button, ProgressBar } from "react-bootstrap";
import { FleetStatsModal } from "pages/dashboard/main/widgets/fleet_stats/FleetStatsModal";
import { FaCircle } from "react-icons/fa";
import { FormattedNumber } from "react-intl";
import { useSuperState } from "helpers/hooks";
import { useApp } from "common/context";
import FormattedDuration from "react-intl-formatted-duration";

export const FleetTableRow = props => {

    const { fleet, title } = props;

    const { api } = useApp();

    const [state, setState] = useSuperState({
        error: null,
        loading: true,
        stats: null,
        usage: null,
        queue: null
    });
    const { error, loading, stats, usage, queue } = state;

    const stats_modal = useRef();

    const fetchFleetStats = async () => {

        try {

            const { stats, usage, queue } = await api.get(`/api/appstream/fleet/stats/${fleet}`);
            setState({
                stats,
                usage,
                queue
            });

        } catch (e){

            const error = e?.err || e?.message || e;
            setState({ error });

        }

    };

    const handleDetails = e => {

        e.preventDefault();

        const modal = stats_modal?.current;
        if (!modal) return;

        modal.show(stats);
    };

    useEffect(() => {

        let interval;

        (async () => {

            await fetchFleetStats();

            setState({ loading: false });

            interval = setInterval(fetchFleetStats, 10000);

        })();

        return () => {

            clearInterval(interval);

        };

    }, []);

    const pressure_pct = stats ? stats?.available_user_sessions == 0
        ? 100
        : Math.floor(stats?.active_user_sessions / (stats?.active_user_sessions + stats?.available_user_sessions) * 100)
        : 0;

    const pressure_variant = pressure_pct > 66
        ? 'danger'
        : (pressure_pct > 33
            ? 'warning'
            : 'success');

    if (loading || error) return <></>;

    const STATUS_COLORS = {
        STARTING: 'info',
        RUNNING: 'success',
        STOPPING: 'warning',
        STOPPED: 'danger'
    };

    return (
        <tr>
            <td style={{ verticalAlign: 'middle' }}>
                <strong>
                    {title}
                </strong>
            </td>

            <td style={{ verticalAlign: 'middle' }}>
                <div className="d-flex align-items-center gap-1">
                    <FaCircle className={`text-${STATUS_COLORS?.[stats.state] || 'muted'} me-1`}/>
                    <span className="text-capitalize">
                        {stats?.state?.toLowerCase() || 'unknown'}
                    </span>
                </div>
            </td>

            <td style={{ verticalAlign: 'middle' }}>
                <span>
                    {`${stats?.active_user_sessions}/${stats?.active_user_sessions + stats?.available_user_sessions}`}
                </span>
            </td>

            <td style={{ verticalAlign: 'middle' }}>
                <span>
                    {queue?.current_queue_count || 0}
                </span>
            </td>

            <td style={{ verticalAlign: 'middle' }}>
                {stats?.state == 'RUNNING' && (
                    <div className="d-flex align-items-center">
                        <div className="w-100">
                            <ProgressBar
                                now={pressure_pct}
                                variant={pressure_variant}
                        />
                        </div>
                        &nbsp;
                        {pressure_pct}%
                    </div>
                )}
            </td>

            <td style={{ verticalAlign: 'middle' }} className="text-center">
                <FormattedNumber value={usage?.session_count_24hrs}/>
            </td>

            <td style={{ verticalAlign: 'middle' }} className="text-center">
                <FormattedNumber value={usage?.session_count_today}/>
            </td>

            <td style={{ verticalAlign: 'middle' }} className="text-center">
                <FormattedNumber value={usage?.minutes_today}/>
            </td>

            <td style={{ verticalAlign: 'middle' }} className="text-center d-none d-md-table-cell">
                <FormattedDuration
                    seconds={queue?.current_wait_time || 0}
                    unitDisplay="short"
                    format="{minutes} {seconds}"
                />
            </td>

            <td className="text-end">
                {stats?.state == 'RUNNING' && (
                    <Button variant="secondary" onClick={handleDetails}>
                        Details
                    </Button>
                )}
            </td>

            <FleetStatsModal ref={stats_modal}/>

        </tr>
    );
};